export default (num) => {
  while (num < 1) {
    num += 12
  }
  while (num > 12) {
    num -= 12
  }
  return num
}
